import CrispHelper from '@rmp-shared/helpers/crisp-helper/crisp-helper';

export default class CrispManager {
  constructor() {
    const triggerEls = document.body.querySelectorAll('[data-crisp-trigger]');
    triggerEls.forEach(t => {
      t.addEventListener('click', this.clickPerformed);
    });
  }

  clickPerformed() {
    CrispHelper.openChat();
  }
}
